.ux-info-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: max-content;
    padding: 5px 15px;

    p {
        color: $color-white;
    }

    &--type-info {
        background-color: $color-blue-info;
        color: $color-white;
        fill: $color-white;
    }

    &--type-error {
        border: 1px solid $color-red-error;
        color: $color-red-error;
        fill: $color-red-error;

        p {
            color: $color-red-error;
        }
    }

    .ux-icon {
        margin-right: 15px;
    }
}
